import { Injectable } from '@angular/core';
import { ObservationVariable } from '../../../shared/model/observation-variable.model';

@Injectable({
    providedIn: 'root'
})
export class VariableUtilityService {

    constructor() {
    }

    consolidatePairVariables(observationVariables: ObservationVariable[]) {

        if (!observationVariables || observationVariables.length === 0) {
            return [];
        }

        // Make a copy of the input array
        const observationVariablesCopy = [...observationVariables];

        // Create a lookup object of variables by their termId
        const variablesById = observationVariablesCopy.reduce((acc, variable) => {
            acc[variable.termId] = variable;
            return acc;
        }, {} as { [key: number]: ObservationVariable });

        // Variables to be filtered out (NAME variables in ID-NAME pairs)
        const variablesToFilter = new Set<number>();

        // Process pairs, transferring properties from NAME to ID variables
        observationVariablesCopy.forEach(observationVariable => {
            const translatedVariableId = this.getIDPairByVariableId(observationVariable.termId);
            if (translatedVariableId !== observationVariable.termId) {
                // This is a NAME variable with a corresponding ID variable
                const idVariable = variablesById[translatedVariableId];
                if (idVariable) {
                    // Transfer properties from NAME to ID variable
                    idVariable.alias = observationVariable.alias;
                    idVariable.name = observationVariable.name;
                    // Mark NAME variable for filtering
                    variablesToFilter.add(observationVariable.termId);
                }
            }
        });

        // Return the array of variables, filtering out NAME variables
        return observationVariablesCopy.filter(variable => !variablesToFilter.has(variable.termId));
    }

    getIDPairByVariableId(variableId: number): number {
        // These three variables need special handling - their IDs must be translated before sending to the server
        // Variable Name -> Variable ID
        const idTranslations: { [key: number]: number } = {
            // Collaborator
            8373: 8372,
            // PI Name
            8100: 8110
        };

        // Check if the id is in our list of necessary translations. If it is, return the translation; otherwise, return itself.
        return idTranslations[variableId] ?? variableId;
    }

    getNamePairByVariableId(variableId: number) {
        // These three variables need special handling - their IDs must be translated before sending to the server
        // Variable ID -> Variable Name
        const idTranslations: { [key: number]: number } = {
            // Collaborator
            8372: 8373,
            // PI Name
            8110: 8100
        };

        // Check if the id is in our list of necessary translations. If it is, return the translation; otherwise, return itself.
        return idTranslations[variableId] ?? variableId;
    }
}
